import React, { ReactNode } from 'react';
import Link from 'next/link';
import url from '@/utils/config';
import { useRouter } from 'next/router';

type Props = {
  href: string;
  children: ReactNode;
  onClick?: (e: React.UIEvent<Element, UIEvent>) => void; // onClickはオプショナル
};

/**
 * 戻る見た目を持ちつつ、任意の前処理後に指定先へ遷移できるリンク。
 * @param props 遷移先、表示文言、任意の前処理
 * @returns 戻るリンクボタン
 */
const BackLinkButton = ({ href, children, onClick }: Props) => {
  const router = useRouter();
  const handleClick = (e: React.UIEvent<Element, UIEvent>) => {
    if (!onClick) return;
    // 保存や state 更新などの前処理を済ませてから明示的に遷移する。
    e.preventDefault();
    onClick(e);
    router.push(href);
  };
  return (
    <Link href={href} className='m-button-back__inner' onClick={onClick ? handleClick : undefined}>
      <img className='m-button__icon' src={url('/images/icon-arrow_left.svg')} alt='' />
      <span className='m-button-back__txt'>{children}</span>
    </Link>
  );
};

export default BackLinkButton;
